import React, { useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import LogoN from '../../assets/img/NAFIL_logoCurto.svg';
import QRCodeStyling from 'qr-code-styling'; // Supondo que você esteja usando essa biblioteca para gerar o QR code

function QRCode({ openDialogoQRCodePixPayLoad }) {
  const qrCodeRef = useRef(null);

  console.log("ENTREI QRcodi ", openDialogoQRCodePixPayLoad);
  
  async function verificarPagamentosPIX(a, b) {
    // if (_dadosPedido?.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).length > 0) { // 17
    //   _dadosPedido.especie.filter((xp) => xp.nband == 17 && xp.pix_recebido == null).map((xpag) => { // 17
    //     api.get(`Pedidos/PIXVerificarPagamentoEfetuado/${xpag.venda_id}/${xpag.venda_loja}/${xpag.especie_id}/${xpag.especie_loja}/${xpag.valor}`).then(res => {
    //       if (res.status == 200 && res?.data != null && res?.data?.message == null) {
    //         // SUCESSO NO RECEBIMENTO DO PIX
    //         sucessoMensagem("PIX Recebido com Sucesso!");
    //         xpag.pix_Recebido = res.data;
    //         setUrlQRCode('');
    //         setShowModalMeuPedido(false);
    //         return;
    //       }
    //     }).catch(err => {
    //       return false;
    //     });
    //   })
    // }
    // FAZER AQUI
  }


  useEffect(() => {        
    if (openDialogoQRCodePixPayLoad != null && openDialogoQRCodePixPayLoad.length > 0) {
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        data: openDialogoQRCodePixPayLoad,
        image: LogoN,
        dotsOptions: {
          color: "#000000",
          type: "rounded"
        },
        imageOptions: {
          crossOrigin: "anonymous",
          margin: 5
        }
      });

      qrCode.append(qrCodeRef.current);
      // qrCode.update({
      // data: openDialogoQRCodePixPayLoad
      // });

      const intervalID = setInterval(verificarPagamentosPIX, 6000, 'Parameter 1', 'Parameter 2');

      return () => clearInterval(intervalID); // Limpar intervalo ao desmontar o componente
    }
  }, []);

  return (
    <Grid container spacing={2} justifyContent="center" alignItems="center">
      <Grid item xs={12} height={300}>
        <div ref={qrCodeRef}></div>
      </Grid>
    </Grid>
  );
}
export default QRCode;
